import React from 'react';
import { Link } from 'react-router-dom';
import { FaMedal, FaTools, FaIndustry, FaAward } from 'react-icons/fa';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <section className="about-section home-section">
      <div className="section-header">
        <h2 className="section-title">About Global Business Combine</h2>
        <p className="section-subtitle">
          Your trusted partner for high-quality industrial tools and solutions since 1990
        </p>
      </div>

      <div className="about-content">
        <div className="about-text">
          <p>
            Global Business Combine (GBC) is your trusted partner for high-quality tungsten carbide dies, 
            diamond tools, and abrasives. With over three decades of experience, we are an ISO 9001-2008 
            certified company, committed to innovation and excellence in industrial tooling solutions.
          </p>
          <p>
            Our tools are known for their efficiency, durability, and versatility, serving industries 
            worldwide, including aerospace, automotive, electronics, and precision manufacturing. At GBC, we 
            prioritize customer satisfaction through precision engineering, ethical business practices, and 
            a dedicated team of experts.
          </p>
          <Link to="/about" className="btn about-btn">
            Learn More About Us
          </Link>
        </div>

        <div className="about-features">
          <div className="feature-card">
            <div className="feature-icon">
              <FaMedal />
            </div>
            <h3 className="feature-title">ISO 9001-2008 Certified</h3>
            <p className="feature-desc">
              Our products meet the highest international standards for quality management and reliability.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaTools />
            </div>
            <h3 className="feature-title">30+ Years Experience</h3>
            <p className="feature-desc">
              Decades of expertise in creating precision tools for aerospace, automotive, and electronics industries.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaIndustry />
            </div>
            <h3 className="feature-title">Global Service</h3>
            <p className="feature-desc">
              Serving precision manufacturing industries worldwide with efficient and durable tooling solutions.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaAward />
            </div>
            <h3 className="feature-title">Customer Satisfaction</h3>
            <p className="feature-desc">
              Committed to excellence through precision engineering, ethical practices, and a dedicated expert team.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
